import { useEffect } from 'react';
import {
    GelModal,
    GelParagraph,
    GelBoxLayout,
    GelRowLayout,
    GelButton,
    GelSpinner
} from '@tal-gel/components';
import { getGelTokens } from '@tal-gel/theming';
import { useClickGate } from "./useClickGate";
import { useStagedUploadsStore, stagedUploadsActions, STAGED_FILE_STATUS } from "./stagedUploadsStore";
import { useGetClaimDetailsContent } from '../../../common/api/graphQLDataFetch';

interface PendingStagedFilesModalProps { }
const PendingStagedFilesModal = ({ }: PendingStagedFilesModalProps) => {
    const { global: { sizeBaseUnit } } = getGelTokens()
    const { data, isLoading } = useGetClaimDetailsContent()
    
    const enabled = useStagedUploadsStore(s => 
        s.some(x => 
            x.files.some(f => 
                f.status === STAGED_FILE_STATUS.UPLOADING ||
                f.status === STAGED_FILE_STATUS.SCANNING ||
                f.status === STAGED_FILE_STATUS.SANITISED ||
                f.status === STAGED_FILE_STATUS.SUCCESS
            )
        ));

    const gate = useClickGate({
        enabled,
        onProceed: () => stagedUploadsActions.clear(),
    });

    // Attach at document to avoid wrapping App
    useEffect(() => {
        const h = (e: MouseEvent) => gate.onRootClickCapture(e as any);
        document.addEventListener("click", h, true);   // capture
        return () => document.removeEventListener("click", h, true);
    }, [gate.onRootClickCapture]);

    if (!gate.open) return null;

    if (isLoading)
        return (<GelSpinner medium overlay />)

    return (
        <GelModal
            width="sm"
            open={true}
            onClose={() => gate.close(false)}
            closeOnBackdropClick={false}
            sticky
            title={data?.files?.NavGuard?.Title}
            action={
                <GelBoxLayout gap="small" space="auto">
                    <GelButton
                        secondary medium
                        width={sizeBaseUnit * 22}
                        onClick={() => gate.close(true)}
                        style={{
                            width: sizeBaseUnit * 40,
                        }}
                    >
                        {data?.files?.NavGuard?.Action?.Cancel}
                    </GelButton>

                    <GelButton
                        primary medium
                        width={sizeBaseUnit * 22}
                        onClick={() => gate.close(false)}
                        style={{
                            width: sizeBaseUnit * 40,
                        }}
                    >
                        {data?.files?.NavGuard?.Action?.Approve}
                    </GelButton>
                </GelBoxLayout>
            } >
            <GelRowLayout gutter="small">
                <GelParagraph 
                    dangerouslySetInnerHTML={{ __html: data?.files?.NavGuard?.Body || '' }}>
                </GelParagraph>
            </GelRowLayout>
        </GelModal>
    );
}

export default PendingStagedFilesModal;
